import { render, staticRenderFns } from "./rules.vue?vue&type=template&id=7f81209a&scoped=true&"
import script from "./rules.vue?vue&type=script&lang=js&"
export * from "./rules.vue?vue&type=script&lang=js&"
import style0 from "./rules.vue?vue&type=style&index=0&id=7f81209a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../55/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f81209a",
  null
  
)

export default component.exports